import React, { useState } from 'react';
import Search from './Search';
import { getLabel } from '../../data/labels';
import SearchAlt from './SearchAlt';
import { systemCode } from '../..';

export default function SearchButton(props) {
    const [toggled, setToggled] = useState(false);

    function toggle() {
        setToggled(!toggled);
    }

    if (systemCode === 'WILLIAMHILL') {
        return (
            <>
                <div className='searchFilter__wrapper'>
                    <div className="h-6 w-6 flex items-center justify-center p-1 bg-cc2 rounded-md searchButton__wrapper" onClick={toggle}>
                        <div className='searchButton__title '>
                            <span>{getLabel('general.find')}</span>
                        </div>
                        <i className="bi-search text-lg text-cs1 searchButton__icon"></i>
                    </div>
                    <div>
                        {/* {props.showSortButtonLive && <LiveSortButton />} */}
                        {/* {props.showSortButtonPrematch && <SortTypeButton setSortType={props.setSortType} current={props.current} />} */}
                    </div>
                </div>
                {toggled &&
                    <SearchAlt toggle={toggle} {...props} />
                }
            </>)
    }

    return (
        <>
            <div className="h-6 w-6 flex items-center justify-center p-1 bg-cc2 rounded-md searchButton__wrapper" onClick={toggle}>
                <i className="bi-search text-lg text-cs1 searchButton__icon"></i>
            </div>
            {toggled &&
                <Search toggle={toggle} />
            }
        </>
    );
}
